export enum AgentRouteNames {
  AGENT = 'agent',
}

export enum AgentRoutePathNames {
  AGENT = 'agent',
}

export enum AgentRouteParams {
  CONVERSATION_ID = 'conversationId',
}

export enum AgentLocalePrefix {
  AGENT = 'agent',
}
